import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Stack,
  Typography
} from '@mui/material';
import { appFormUtil } from 'modules/common';
import { StyledInputTextField } from 'modules/components';
import { useCallback } from 'react';
import {
  useNavigate,
  useParams
} from 'react-router-dom';
import * as ds from './dataService';



export type InviteUserModalProps = {
  isVisible: boolean;
  organizationId?: string;
  onClose: () => void;
};


export const FC = (props: InviteUserModalProps) => {
  const navigate = useNavigate();
  const { organizationId } = useParams<{ organizationId: string }>();
  const queryTuple = ds.useQuery(organizationId);

  const {
    formState,
    genFieldProps
  } = appFormUtil.useFormState({
    initialState: {
      email: ''
    },
    key2FieldConfig: {
      email: {
        label: 'User Email',
        type: 'email',
        required: true
      }
    }
  });

  const [fnInviteUser] = ds.useSendInvite();



  const handleSendInvite = useCallback(async () => {
    try {
      await fnInviteUser({
        email: formState.email,
        organizationId: props.organizationId
      });
      props.onClose();

    } catch (err) {
      if (err instanceof Error) {
        window.alert(err.message);
      }
    }
  }, [
    fnInviteUser,
    formState.email,
    props
  ]);



  return (
    <Dialog
      open={props.isVisible}
      maxWidth='md'
      onClose={props.onClose}
    >
      <DialogTitle>
        Invite User
      </DialogTitle>

      <DialogContent>
        <Stack
          divider={<Divider />}
          gap={1}
        >
          {organizationId && (
            <Typography>
              Manage your seats and invite more people to your organization.
            </Typography>
          )}

          {organizationId && (
            <Stack gap={1}>
              <Typography variant='formLabel'>
                Current Seats:
              </Typography>

              <Typography>
                {queryTuple.data.currentMembershipCount} of {queryTuple.data.seatCount} used
              </Typography>

              <Button
                variant='contained'
                onClick={() => navigate(`/account/${organizationId}/subscription`, {
                  state: {
                    openManageSeatsModal: true
                  }
                })}
              >
                Manage Seats
              </Button>
            </Stack>
          )}

          <StyledInputTextField.FC
            disabled
            {...genFieldProps('email')}
          />
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button
          variant='outlined'
          color='secondary'
          onClick={props.onClose}
        >
          Cancel
        </Button>

        <Button
          variant='contained'
          disabled={!queryTuple.data.canInviteUser}
          onClick={handleSendInvite}
        >
          {queryTuple.data.canInviteUser ? 'Invite' : 'No open seats'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
